import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { BlockModuleService } from '../../services/shared/block-module.service';
import { map, tap } from 'rxjs/operators';
import { BlockModule } from '../../model/blockModule';
import { Response } from '../../model/response';

export const blockModuleGuard: CanActivateFn = () => {
  const blockModuleService = inject(BlockModuleService)

  return blockModuleService.getInfoBlockModule<Response<BlockModule>>().pipe(
    tap(response => {
      console.log('response gurd', response)
      if (response.data.blocked) {
        blockModuleService.openModal()
      }
    }),
    map(() => true)
  )
};
